import Style from '../style/appbar.module.scss'

const HappySuccess = ({ h3Text = "", h5Text = "", h6Text = "" }) => {
    return (
        <div className={Style.happyBox}>
            <div className={Style.avatarBox} />
            <div className={Style.infoBox}>
                {h3Text?.length > 0 && <h3>{h3Text}</h3>}
                {h5Text?.length > 0 && <h5>{h5Text}</h5>}
                {h6Text?.length > 0 && <h6>{h6Text}</h6>}
            </div>
        </div>
    )
}

export default HappySuccess